import script from "./BlueTitleToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueTitleToggle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__